import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-scheduled-start-date';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Scheduled start date/time',
};

const sstScheduledStartDate = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstScheduledStartDate };
